import React from "react";

const Empresas = () => {
  return (
    <div>
      <h1>Empresas</h1>
      <p>Aqui as empresas podem visualizar os candidatos cadastrados.</p>
    </div>
  );
};

export default Empresas;
